import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Контейнер в топбаре, куда раздел кладёт своё главное действие.
 * Значение появляется после первого рендера Layout — до этого слот пуст.
 */
const TopbarSlotContext = createContext<HTMLElement | null>(null);

export const TopbarSlotProvider = TopbarSlotContext.Provider;

/**
 * Главное действие раздела живёт в топбаре, а не над содержимым: строка
 * заголовка на странице тогда не нужна вовсе, а кнопка остаётся на виду при
 * скролле — топбар прилипший.
 *
 * Вне Layout (например, в тестах страницы) слота нет и действие не рисуется:
 * страница отвечает за содержимое, кнопка — за топбар.
 */
export function TopbarActions({ children }: { children: ReactNode }): JSX.Element | null {
  const slot = useContext(TopbarSlotContext);

  if (!slot) return null;

  return createPortal(children, slot);
}
